import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-035917a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-loader" }

import MainLogo from "@/components/MainLogo.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AppLoader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainLogo, { class: "app-loader__logo" })
  ]))
}
}

})